module.exports = __webpack_public_path__ + "img/Portal-img.82ebb1e9.jpg";